import script from "./QEmptyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./QEmptyContent.vue?vue&type=script&setup=true&lang=js"

import "./QEmptyContent.vue?vue&type=style&index=0&id=5677400e&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5677400e"]])

export default __exports__